import axios from 'axios';
import {
  MERCHANT_CREATE_REQUEST, MERCHANT_CREATE_SUCCESS, MERCHANT_CREATE_FAIL,
  MERCHANT_BY_QR_REQUEST, MERCHANT_BY_QR_SUCCESS, MERCHANT_BY_QR_FAIL,
  MERCHANT_LIST_REQUEST, MERCHANT_LIST_SUCCESS, MERCHANT_LIST_FAIL,
} from '../constants/merchantConstants';

const baseUrl = process.env.REACT_APP_API_URL; // e.g. http://localhost:5000/api

/// change signature to include qrNumber
export const createMerchant = (payload) => async (dispatch, getState) => {
   try {
    dispatch({ type: MERCHANT_CREATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
      },
    };

   const { data } = await axios.post(`${baseUrl}/merchants`, payload, config);
    dispatch({ type: MERCHANT_CREATE_SUCCESS, payload: data }); // { merchant, qrToken, formUrl, qrDataUrl }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: MERCHANT_CREATE_FAIL,
      payload: message,
    });
    throw new Error(message);
  }
};

export const createPublicMerchant = (payload) => async (dispatch) => {
  try {
    dispatch({ type: MERCHANT_CREATE_REQUEST });
    const { data } = await axios.post(`${baseUrl}/merchants/public`, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    dispatch({ type: MERCHANT_CREATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: MERCHANT_CREATE_FAIL,
      payload: message,
    });
    throw new Error(message);
  }
};

// Universal-page onboarding; QR assignment is deferred to an admin.
export const createUniversalMerchant = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: MERCHANT_CREATE_REQUEST });
    const userInfo = getState().userLogin?.userInfo;
    const endpoint = userInfo?.token ? '/merchants/universal' : '/merchants/universal/public';
    const { data } = await axios.post(`${baseUrl}${endpoint}`, payload, {
      headers: {
        'Content-Type': 'application/json',
        ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {}),
      },
    });
    dispatch({ type: MERCHANT_CREATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({ type: MERCHANT_CREATE_FAIL, payload: message });
    throw new Error(message);
  }
};
export const approveMerchant = (merchantId) => async (dispatch, getState) => {
  const { userLogin: { userInfo } } = getState();
  const config = {
    headers: { 'Content-Type': 'application/json', ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {}) },
  };
  const { data } = await axios.put(`${baseUrl}/merchants/${merchantId}/approve`, {}, config);
  return data;
  // You might want to refresh list/detail in the component after calling this.
};

// PUBLIC: resolve merchant by QR token
export const getMerchantByQr = (qrToken) => async (dispatch) => {
  try {
    dispatch({ type: MERCHANT_BY_QR_REQUEST });
    const { data } = await axios.get(`${baseUrl}/merchants/qr/${qrToken}`);
    dispatch({ type: MERCHANT_BY_QR_SUCCESS, payload: data }); // { _id,name,qrToken,status }
  } catch (error) {
    dispatch({
      type: MERCHANT_BY_QR_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getSystemMerchant = () => async (_dispatch, getState) => {
  const userInfo = getState().userLogin?.userInfo;
  try {
    const { data } = await axios.get(`${baseUrl}/merchants/system`, {
      headers: {
        ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {}),
      },
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

// ADMIN: list merchants
// actions/merchantActions.js
export const listMerchants = ({ page = 1, limit = 10, q = '', status, location } = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: MERCHANT_LIST_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
      },
      params: {
        page,
        limit,
        q,
        // only send when not 'all' to keep URLs clean
        ...(status && status !== 'all' ? { status } : {}),
        ...(location && location !== 'all' ? { location } : {}),
      }
    };

    const { data } = await axios.get(`${baseUrl}/merchants`, config);
    dispatch({ type: MERCHANT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: MERCHANT_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const toggleMerchantStatus = (merchantId) => async (dispatch, getState) => {
  const { userLogin: { userInfo } } = getState();
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
    }
  };
  await axios.put(`${baseUrl}/merchants/${merchantId}/toggle`, {}, config);
};

export const updateMerchant = (merchantId, payload) => async (_dispatch, getState) => {
  const { userLogin: { userInfo } } = getState();
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
    }
  };
  const { data } = await axios.put(`${baseUrl}/merchants/${merchantId}`, payload, config);
  return data;
};

export const deleteMerchant = (merchantId) => async (_dispatch, getState) => {
  const { userLogin: { userInfo } } = getState();
  const config = {
    headers: {
      ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
    }
  };
  const { data } = await axios.delete(`${baseUrl}/merchants/${merchantId}`, config);
  return data;
};

export const deleteManyMerchants = (ids) => async (_dispatch, getState) => {
  const { userLogin: { userInfo } } = getState();
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {})
    },
    data: { ids },
  };
  const { data } = await axios.delete(`${baseUrl}/merchants/bulk`, config);
  return data;
};
